import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import ReorderIcon from '@mui/icons-material/Reorder';
import * as Table from '../Table';
import { cx } from '@trinity/chat-components/utils';
import styles from './styles/Draggable.module.css';

type Props = {
  depth?: 1 | 2;
  hidden?: boolean;
} & Partial<DraggableProvidedDragHandleProps>;

export const Cell = ({ depth = 1, hidden, ...props }: Props) => {
  const classnames = cx(
    styles.cell,
    hidden ? styles.hidden : undefined,
    depth > 1 ? styles.child : undefined
  );

  return (
    <Table.Body.TD className={styles.handle}>
      <div className={classnames} {...props}>
        <ReorderIcon />
      </div>
    </Table.Body.TD>
  );
};

Cell.displayName = 'Column.DragHandle.Cell';

export const Header = (props: unknown) => {
  return <Table.Header.TH className={styles.handle} />;
};

Header.displayName = 'Column.DragHandle.Header';
